import { trackSearchFilterCategoryState } from "@javascript/helpers/searchFilterUtilities";

import Accordion, { AccordionContent, AccordionTrigger } from "@javascript/reactComponents/lds/accordion/Accordion";
import Chip from "@javascript/reactComponents/lds/chips/Chip";
import Divider from "@javascript/reactComponents/lds/Divider";
import FilterItem from "@javascript/reactComponents/lds/FilterItem";
import Icon from "@javascript/reactComponents/lds/Icon";
import Heading from "@javascript/reactComponents/lds/typography/Heading";

const CRM_KEY = "crm";
const NEGLECTED_KEY = "exclude_recent_sponsor";
const MUTED_KEY = "exclude_muted_companies";

function SalesforceFilterItem({selected, onClick}) {
  const leadingContent =  <>
      <Icon name="checkbox" filled={selected} />
      <Icon name="salesforce-v2-filled" style={{ backgroundColor: "var(--color-icon-special-sf)" }} />
    </>

  return (
    <FilterItem
      id="salesforce-filter-item"
      label={I18n.t('terminology.companies_in_your_sf_label')}
      leadingContent={leadingContent}
      onLeadingContentClick={ () => {onClick(CRM_KEY, selected)} }
      selected={selected}
      tooltip="Filter events by companies you have in your Salesforce."
    />
  )
}

function NeglectedFilterItem({selected, onClick}) {
  const leadingContent = <Icon name="checkbox" filled={selected} />

  return (
    <FilterItem
      id="neglected-filter-item"
      label={ I18n.t('terminology.neglected_target_label') }
      leadingContent={leadingContent}
      onLeadingContentClick={ () => {onClick(NEGLECTED_KEY, selected)} }
      selected={selected}
      tooltip={`Filter events by companies that do not have Salesforce Activity by your ${I18n.t('brand.name')} team in the last 6 months.`}
    />
  )
}

function MutedCompaniesFilterItem({selected, onClick}) {
  const onEditClick = function(event) {
    event.preventDefault();
    event.stopPropagation();
    locationRedirect('/settings/muted_companies/edit');
  }

  const leadingContent = <Icon name="checkbox" filled={selected} />
  const trailingContent = <span className="lds-text-link" id="edit_muted_companies" onClick={onEditClick}>Edit</span>

  return (
    <FilterItem
      id="muted-companies-filter-item"
      label="Hide My Muted Companies"
      leadingContent={leadingContent}
      onLeadingContentClick={ () => {onClick(selected)} }
      selected={selected}
      tooltip="Filter events to show your unmuted companies only."
      trailingContent={trailingContent}
    />
  )
}

/**
 * React component
 *
 * Shows checkboxes to filter the search by relationship to company.
 * Displays according to options set through the FacetSearchStore. Will trigger a new facet search on change.
 *
 * @component
 * */

const CompanyRelationshipSelector = createReactClass({
  mixins: [Reflux.connectFilter(FacetSearchStore, function (data) { return data.relationships } )],
  getInitialState() {
    return {
      ...FacetSearchCompanyRelationshipSlice,
      open: true,
    }
  },
  handleCheckboxChange: function (checkboxKey, currentlySelected) {
    if (currentlySelected) {
      FacetSearchCompanyRelationshipActions.removeCompanyRelationship(checkboxKey);
    } else {
      FacetSearchCompanyRelationshipActions.addCompanyRelationship(checkboxKey);
    }
  },
  handleMutedCompaniesChange: function (currentlySelected) {
    if (!currentlySelected) {
      Zymewire.external_track_action(
        'exclude_muted_companies applied in search'
      )
    }

    this.handleCheckboxChange(MUTED_KEY, currentlySelected);
  },
  handleAccordionToggle: function () {
    trackSearchFilterCategoryState(!this.state.open, "company_relationship");
    this.setState({ open: !this.state.open });
  },

  render: function() {
    const relationshipsSelected = this.state.selected;

    const trailingAction = (
      <>
        <div className="flex-grow-1" />
        <Chip
          label=""
          selected={this.state.open}
          size="small"
          leadingIcon={`chevron-${this.state.open ? "up" : "down"}-centered`}
          variant={this.state.open ? "primary" : "secondary"}
        />
      </>
    );

    return (
      <>
        <Divider className="facet-search-section-divider" size="small" variant="secondary" />
        <Accordion open={this.state.open} className="filter_category relationships-accordion">
          <AccordionTrigger className="cursor-pointer" onClick={ this.handleAccordionToggle }>
            <Heading
              leadingIcon="company_relationship"
              size="h3"
              tooltip="Filter events based on your relationships to the organizations involved."
              trailingAction={trailingAction}
            >
              {Zymewire.facet_search_filters.company_relationship}
            </Heading>
          </AccordionTrigger>
          <AccordionContent className="relationship-filters-body filter_category_inner" gap="var(--filter-category-space-gap)">
            {
              (this.state.authorizedSalesForce && this.state.salesforceCurrentlyProcessing) &&
              <SalesforceFilterItem
                selected={_.contains(relationshipsSelected, CRM_KEY)}
                onClick={ this.handleCheckboxChange }
              />
            }

            {
              this.state.authorizedSalesForce &&
              <NeglectedFilterItem
                selected={_.contains(relationshipsSelected, NEGLECTED_KEY)}
                onClick={ this.handleCheckboxChange }
              />
            }

            <MutedCompaniesFilterItem
              selected={_.contains(relationshipsSelected, MUTED_KEY)}
              onClick={ this.handleMutedCompaniesChange }
            />
          </AccordionContent>
        </Accordion>
      </>
    )
  }
});

window.CompanyRelationshipSelector = CompanyRelationshipSelector;
export default CompanyRelationshipSelector;
